import { IPaginationRequest } from "interfaces/pagination";
import axios from "axios";

const StoreService = axios.create({
  baseURL: `${process.env.REACT_APP_API}/store`,
});

const StoreServices = {
  getDetail: (token: string, line_oa_code: string, id: string) =>
    StoreService.get(`/${line_oa_code}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  getAll: (
    token: string,
    line_oa_code: string,
    pagination: IPaginationRequest
  ) =>
    StoreService.get(
      `/${line_oa_code}/list?perPage=${pagination.per_page}&page=${pagination.page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
  create: (
    token: string,
    line_oa_code: string,
    data: {
      name: string;
      lat: number;
      lng: number;
      address: string;
      tel: string;
      url: string;
    }
  ) =>
    StoreService.post(`/${line_oa_code}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  edit: (
    token: string,
    line_oa_code: string,
    id: string | number,
    data: {
      name: string;
      lat: number;
      lng: number;
      address: string;
      tel: string;
      url: string;
    }
  ) =>
    StoreService.put(`/${line_oa_code}/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  delete: (token: string, line_oa_code: string, id: string | number) =>
    StoreService.delete(`/${line_oa_code}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
};

export default StoreServices;
